import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PicDetailPage } from './pic-detail.page';

const routes: Routes = [
  {
    path: '',
    component: PicDetailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PicDetailPageRoutingModule {}
